import { Box, Paper } from "@mui/material";
import React from "react";
import { customValue } from "../../../utils/colorVariable";

interface ITableContainer {
  children: React.ReactNode;
}

export const TableContainer: React.FC<ITableContainer> = ({ children }) => {
  return (
    <Box
      sx={{ height: "100%" }}
      component={Paper}
      borderRadius={customValue.borderRadius}
      padding={2}
    >
      {children}
    </Box>
  );
};
